import {
  removeToken,
  setTokenLocalStorage,
  setTokenSessionStorage,
} from '@config/storage';
import { disposeWsClient } from '@config/wsClient';
import { User } from '@models/user.model';

export const UserTypes = {
  SET_USER_DATA: 'SET_USER_DATA',
  SET_USER_DETAILS: 'SET_USER_DETAILS',
  LOGOUT_USER: 'LOGOUT_USER',
  UPDATE_SIDEBAR_STATUS: 'UPDATE_SIDEBAR_STATUS',
};

export const setUserData = (token: string, rememberMe: boolean) => {
  if (rememberMe) {
    setTokenLocalStorage(token);
  } else {
    setTokenSessionStorage(token);
  }
  return {
    type: UserTypes.SET_USER_DATA,
    data: { token, rememberMe },
  };
};

export const setUserDetails = (details: Partial<User>) => {
  return {
    type: UserTypes.SET_USER_DETAILS,
    data: details,
  };
};

export const updateSidebarStatus = () => {
  return {
    type: UserTypes.UPDATE_SIDEBAR_STATUS,
    data: {},
  };
};

export const logoutUser = () => {
  removeToken();
  // Close the subscription socket before the token goes away, so it cannot
  // reconnect with the departing user's identity.
  disposeWsClient();
  //TODO: Check if we want to implement it here
  window.open(process.env.REACT_APP_LOGOUT_URL, '_self');
  return {
    type: UserTypes.LOGOUT_USER,
    data: {},
  };
};

export type UserState = {
  userId: string | null;
  isLoggedIn: boolean;
  collapsedSidebar?: boolean;
  email?: string | null;
  firstName?: string | undefined | null;
  lastName?: string | undefined | null;
  role: string | null;
  avatar?: string | null;
  rememberMe?: boolean;
  status?: string | null;
  isReadOnly?: boolean;
};

// INITIAL STATE
const userInitialState: UserState = {
  userId: null,
  isLoggedIn: false,
  collapsedSidebar: false,
  email: null,
  role: null,
  avatar: '',
  firstName: '',
  rememberMe: false,
  status: null,
  isReadOnly: false,
};

export type UserAction = {
  type: string;
  data: User;
};

const userReducer = (state = userInitialState, action: UserAction) => {
  switch (action.type) {
    case UserTypes.SET_USER_DATA:
      return {
        ...state,
        isLoggedIn: true,
        rememberMe: action.data.rememberMe,
      };

    case UserTypes.SET_USER_DETAILS:
      return {
        ...state,
        ...action.data,
        isLoggedIn: true,
      };

    case UserTypes.UPDATE_SIDEBAR_STATUS:
      return {
        ...state,
        collapsedSidebar: !state.collapsedSidebar,
      };

    case UserTypes.LOGOUT_USER:
      return {
        ...state,
        ...userInitialState,
      };

    default:
      return state;
  }
};

export default userReducer;
